import type { PartyMember } from '@shefira/shared';

/** The frames' order (ADR 0032): the player first, then the others as the server sent them. */
export function partyOrder(members: readonly PartyMember[], selfId: string): PartyMember[] {
  const self = members.filter((member) => member.id === selfId);
  return [...self, ...members.filter((member) => member.id !== selfId)];
}
